<template>
  <button class="buttonGeneralC" :disabled="this.disabled || false">
    <h2 class="h2-hero">{{ texto }}</h2>
  </button>
  <!-- </div> -->
</template>
<script>
export default {
  name: "BtnCComponent",
  props: {
    texto: String,
    disabled: Boolean,
    modal: Boolean,
  },
};
</script>
<style scoped>
h2 {
  margin: 0px;
  color: var(--text-primary);
}
.buttonGeneralC {
  border-radius: 0.5rem;
  text-align: center;
  align-content: center;
  max-width: 23.71vw;
  min-width: 18.302vw;
  border: 1px solid var(--text-primary);
  height: var(--margin40);
  background: none;
  padding: 1.669vh 0.732vw;
}

@media (max-width: 770px) {
  .buttonGeneralC {
    border-radius: 0.5rem;
    text-align: center;
    align-content: center;
    min-width: 36.5vw;
    max-width: unset;
    border: 1px solid var(--text-primary);
    height: var(--gap30);
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /* .buttonGeneral p {
    font-size: 15px;
    font-weight: 800;
  }
  .buttonGeneral {
    height: 40px;
    border-radius: 10px;

    align-items: center;
    align-content: center;
    min-width: 100px;
    border: none;
    padding: 0px 15px 0px;
  } */
}

@media (max-width: 460px) {
  .buttonGeneralC {
    border-radius: 8px;
    text-align: center;
    align-content: center;
    padding: 10px;

    min-width: 32.5vw;
    border: 1px solid var(--text-primary);
    height: var(--gap30);
    background: none;
    display: flex;
    align-items: center;
  }
}
</style>
